import { FC, PropsWithChildren } from 'react'

import { ClaimDialog } from './components/ClaimDialog/ClaimDialog'
import { Footer } from './components/Footer/Footer'
import { Header } from './components/Header/Header'
import { MenuDrawer } from './components/MenuDrawer/MenuDrawer'

type TProps = {} & PropsWithChildren

const LayoutNew: FC<TProps> = ({ children }) => {
  return (
    <div className="relative flex min-h-full w-full min-w-[calc(22.5rem)] flex-col items-center overflow-hidden bg-palette-black">
      <Header />
      <main className="relative flex w-full flex-1 flex-col">{children}</main>
      <Footer />
      <MenuDrawer />
      <ClaimDialog />
    </div>
  )
}

export { LayoutNew }
